export default __webpack_public_path__ + "static/media/copy-dark.344bb800.svg";